<div class="flex flex-col gap-1 relative">
  <label [for]="placeholder"  class=" text-xs font-medium" *ngIf="label">{{label}}
    <span *ngIf="required" class="text-red-500">*</span>
  </label>
  <mat-form-field appearance="outline"  [ngClass]="['form-field-wrapper', bgClass, hasError ? 'error-outline':'']">
    <mat-select [formControl]="selectFormControl" (selectionChange)="onSelectionChange()" [placeholder]="placeholder" [multiple]="multiple">
      <ng-container *ngFor="let option of options">
        <mat-option *ngIf="option.type !== 'hidden'" [value]="option['value']" [disabled]="readOnly || option.type === 'disabled' ">{{option.label}}</mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <p class="text-red-600 text-xs absolute error-text">
    <ng-content #content></ng-content>
  </p>
</div>
